(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/coupon-static-row.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/coupon-static-row.js');
"use strict";

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _React = React,
  useMemo = _React.useMemo,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useCallback = _React.useCallback,
  useContext = _React.useContext;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const useBetEvent = svs.components.sportinfo.matchInfoHooks.useBetEvent;
const clx = svs.components.lbUtils.clx;
const _svs$components$tipse = svs.components.tipsen.hooks,
  useBranding = _svs$components$tipse.useBranding,
  useGetSelectedEventNumber = _svs$components$tipse.useGetSelectedEventNumber,
  useIsTipsinfoEnabled = _svs$components$tipse.useIsTipsinfoEnabled;
const baseUrl = svs.core.data.baseUrl;
const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const DescriptionSize = svs.components.lbUi.participants.constants.DescriptionSize;
const TipsinfoTypes = svs.components.tipsen.engine.constants.TipsinfoTypes;
const _svs$components$tipse2 = svs.components.tipsen.couponStatic,
  DistributionDisplay = _svs$components$tipse2.DistributionDisplay,
  ButtonBet = _svs$components$tipse2.ButtonBet,
  TeamNames = _svs$components$tipse2.TeamNames,
  Checkmark = _svs$components$tipse2.Checkmark,
  EventNumber = _svs$components$tipse2.EventNumber,
  EventComment = _svs$components$tipse2.EventComment,
  Init = _svs$components$tipse2.Init;
const TipsenLink = svs.components.tipsen.tipsen_link.TipsenLink;
const _svs$components$sport = svs.components.sport.tipsenShared,
  buttonChoices = _svs$components$sport.buttonChoices,
  getOutcomeLabelsForEventType = _svs$components$sport.getOutcomeLabelsForEventType;
const STATISTIC_SIDEBAR_QUERY = svs.components.tipsen.constants.STATISTIC_SIDEBAR_QUERY;
const useDrawSearchParams = svs.components.tipsen.drawProvider.hooks.useDrawSearchParams;
const Tipsinfo = svs.components.tipsen.tipsinfo.Tipsinfo;
const selectOutcomeInfoChoise = svs.components.tipsen.selectors.selectOutcomeInfoChoise;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD;
const _svs$components$tipse3 = svs.components.tipsen.couponStatic.utils,
  getIsDistributionDisplay = _svs$components$tipse3.getIsDistributionDisplay,
  getProductDistribution = _svs$components$tipse3.getProductDistribution,
  getShouldShowCheckmark = _svs$components$tipse3.getShouldShowCheckmark,
  getShouldShowInit = _svs$components$tipse3.getShouldShowInit,
  getShouldShowTeamNames = _svs$components$tipse3.getShouldShowTeamNames;
const CorrectResult = svs.components.tipsen.couponStatic.CorrectResult;
const RenderContext = svs.component.tipsen.renderContext.RenderContext;
const _svs$components$poolB = svs.components.poolBetting.ariaUtils,
  getAriaLabelForEvent = _svs$components$poolB.getAriaLabelForEvent,
  getOutcomeAriaLabel1X2 = _svs$components$poolB.getOutcomeAriaLabel1X2;
const selectParticipant = svs.components.sportinfo.matchInfoRedux.selectors.selectParticipant;
const selectSportEvent = svs.components.sportinfo.matchInfoRedux.selectors.selectSportEvent;
const getIsOngoing = svs.components.sportinfo.common.matchState.getIsOngoing;
const composeResultUpdateText = svs.components.poolBetting.ariaUtils.composeResultUpdateText;
const getProductBrandByDraw = svs.components.lbUtils.brandMapping.fn.getProductBrandByDraw;
const createCouponRowHref = () => {
  const href = location.pathname.replace(baseUrl, '');
  return href;
};
const getEventClassName = _ref => {
  let isGoalCount = _ref.isGoalCount,
    isSelected = _ref.isSelected,
    mSign = _ref.mSign;
  const mainClassName = 'pg_coupon_static__event';
  return clx(mainClassName, {
    ["".concat(mainClassName, "--selected")]: isSelected,
    ["".concat(mainClassName, "--goal_count")]: isGoalCount,
    ["".concat(mainClassName, "--m_sign")]: mSign
  });
};
const defaultClassList = ['pg_coupon_static__event_container'];
const animationFadeOut = 'fadeOutAnimation';
const CouponStaticRow = _ref2 => {
  var _useSelector, _productDistribution$, _productDistribution$2, _productDistribution$3, _betButtons$drawResul;
  let alwaysIncludeParams = _ref2.alwaysIncludeParams,
    drawCompetitionId = _ref2.drawCompetitionId,
    drawEvent = _ref2.drawEvent,
    drawResult = _ref2.drawResult,
    drawState = _ref2.drawState,
    _ref2$playerBet = _ref2.playerBet,
    playerBet = _ref2$playerBet === void 0 ? [] : _ref2$playerBet,
    sportType = _ref2.sportType,
    drawNumber = _ref2.drawNumber,
    productId = _ref2.productId,
    _ref2$nameSize = _ref2.nameSize,
    nameSize = _ref2$nameSize === void 0 ? DescriptionSize.Full : _ref2$nameSize,
    _ref2$isCompressed = _ref2.isCompressed,
    isCompressed = _ref2$isCompressed === void 0 ? false : _ref2$isCompressed,
    _ref2$distributionCho = _ref2.distributionChoice,
    distributionChoice = _ref2$distributionCho === void 0 ? [] : _ref2$distributionCho,
    _ref2$selectedCouponC = _ref2.selectedCouponChoice,
    selectedCouponChoice = _ref2$selectedCouponC === void 0 ? buttonChoices.GAMES : _ref2$selectedCouponC,
    systemType = _ref2.systemType,
    bestBetRowResult = _ref2.bestBetRowResult,
    mSign = _ref2.mSign,
    uSign = _ref2.uSign,
    hasChangedResult = _ref2.hasChangedResult,
    _ref2$betProperties = _ref2.betProperties,
    betProperties = _ref2$betProperties === void 0 ? [] : _ref2$betProperties,
    distributionForRow = _ref2.distributionForRow;
  const _useContext = useContext(RenderContext),
    isResult = _useContext.isResult,
    pageType = _useContext.pageType;
  const drawId = ''.concat(productId, '_').concat(drawNumber);
  const betButtons = getOutcomeLabelsForEventType(drawEvent.eventTypeId, sportType);
  const isGoalCount = drawEvent.eventTypeId === EventTypeId.GOAL_COUNT;
  const isHead2Head = drawEvent.eventTypeId === EventTypeId.HEAD_TO_HEAD;
  const selectedEventNumber = useGetSelectedEventNumber();
  const isSelected = drawEvent.eventNumber === selectedEventNumber;
  const brandingList = useBranding();
  const brandByDraw = getProductBrandByDraw({
    productId
  });
  const branding = brandByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';
  const outcomeInfoChoice = (_useSelector = useSelector(state => selectOutcomeInfoChoise(state, pageType))) === null || _useSelector === void 0 ? void 0 : _useSelector.display;
  const toParams = useDrawSearchParams(productId, drawNumber, drawEvent.eventNumber, alwaysIncludeParams);
  const searchParams = new URLSearchParams(toParams);
  const showCouponAndDetailView = useMediaQuery(STATISTIC_SIDEBAR_QUERY);
  const sportEvent = useSelector(state => selectSportEvent(state, drawEvent.matchId));
  const isOngoing = sportEvent ? getIsOngoing(sportEvent.sportEventStatus) : undefined;
  if (!showCouponAndDetailView) {
    searchParams.set('openStatistic', '');
  }
  const _useBetEvent = useBetEvent({
      productId,
      drawNumber,
      eventNumber: drawEvent.eventNumber
    }),
    eventStatistics = _useBetEvent.eventStatistics,
    betEvent = _useBetEvent.betEvent;
  const homeParticipant = useSelector(state => {
    var _betEvent$participant;
    return selectParticipant(state, betEvent === null || betEvent === void 0 || (_betEvent$participant = betEvent.participants) === null || _betEvent$participant === void 0 ? void 0 : _betEvent$participant[0]);
  });
  const awayParticipant = useSelector(state => {
    var _betEvent$participant2;
    return selectParticipant(state, betEvent === null || betEvent === void 0 || (_betEvent$participant2 = betEvent.participants) === null || _betEvent$participant2 === void 0 ? void 0 : _betEvent$participant2[1]);
  });
  const productDistribution = getProductDistribution({
    eventStatistics,
    productId,
    drawNumber
  });
  const displayProductDistributionValue = (productDistribution === null || productDistribution === void 0 || (_productDistribution$ = productDistribution.current) === null || _productDistribution$ === void 0 ? void 0 : _productDistribution$.value[0]) && (productDistribution === null || productDistribution === void 0 || (_productDistribution$2 = productDistribution.current) === null || _productDistribution$2 === void 0 ? void 0 : _productDistribution$2.value[1]) && (productDistribution === null || productDistribution === void 0 || (_productDistribution$3 = productDistribution.current) === null || _productDistribution$3 === void 0 ? void 0 : _productDistribution$3.value[2]);
  const betButtonsToShow = useMemo(() => {
    if (outcomeInfoChoice === TipsinfoTypes.SvenskaFolket && displayProductDistributionValue && !isCompressed) {
      return productDistribution.current.value.map((result, index) => _objectSpread(_objectSpread({}, result), {}, {
        resultIndex: index,
        resultText: {
          text: "".concat(result, "%")
        },
        ariaLabel: getOutcomeAriaLabel1X2({
          eventTypeId: drawEvent.eventTypeId,
          postfixSymbol: '%',
          svenskaFolketValue: result,
          sign: betButtons[index].sign,
          homeParticipant,
          awayParticipant
        })
      }));
    }
    const buttonsToReturn = betButtons.map(btn => _objectSpread(_objectSpread({}, btn), {}, {
      resultIndex: betButtons.indexOf(btn),
      resultText: btn,
      ariaLabel: getOutcomeAriaLabel1X2({
        eventTypeId: drawEvent.eventTypeId,
        sign: btn.sign,
        homeParticipant,
        awayParticipant
      })
    }));
    if (isCompressed) {
      return buttonsToReturn.filter(button => button.resultIndex === (drawResult === null || drawResult === void 0 ? void 0 : drawResult.outcome[0][0]));
    }
    return buttonsToReturn;
  }, [outcomeInfoChoice, displayProductDistributionValue, isCompressed, betButtons, productDistribution, drawEvent.eventTypeId, homeParticipant, awayParticipant, drawResult === null || drawResult === void 0 ? void 0 : drawResult.outcome]);
  const _useIsTipsinfoEnabled = useIsTipsinfoEnabled(),
    isAnyTipsinfoEnabled = _useIsTipsinfoEnabled.isAnyTipsinfoEnabled;
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  const _useState = useState(defaultClassList),
    _useState2 = _slicedToArray(_useState, 2),
    classList = _useState2[0],
    setClassList = _useState2[1];
  useEffect(() => {
    if (hasChangedResult) {
      setClassList([...defaultClassList, 'pg_coupon_static__event_container--changed_result']);
    }
  }, [hasChangedResult]);
  const handleAnimationEnd = useCallback(event => {
    if (event.animationName === animationFadeOut) {
      setClassList(defaultClassList);
    }
  }, []);
  const getButtonBetClassNames = () => {
    const classNames = ['pg_coupon_static__bet_buttons'];
    classNames.push("pg_coupon_static__bet_buttons--".concat(branding));
    return classNames.join(' ');
  };
  return React.createElement("li", {
    className: classList.join(' '),
    onAnimationEnd: handleAnimationEnd
  }, React.createElement(TipsenLink, _extends({
    "aria-label": getAriaLabelForEvent({
      eventTypeId: betEvent.eventTypeId,
      homeParticipant,
      awayParticipant
    }),
    className: getEventClassName({
      isGoalCount,
      isSelected,
      mSign
    }),
    disabled: isHead2Head || isSelected && showCouponAndDetailView 
    ,
    to: {
      pathname: createCouponRowHref(),
      search: "?".concat(searchParams)
    }
  }, isSelected ? {
    'aria-current': 'page'
  } : {}), React.createElement("div", {
    className: "pg_coupon_static__event_number"
  }, React.createElement(EventNumber, {
    bestBetRowResult: bestBetRowResult,
    branding: branding,
    drawResult: drawResult,
    eventNumber: drawEvent.eventNumber,
    eventTypeId: drawEvent.eventTypeId,
    isCompressed: isCompressed,
    userRow: playerBet
  })), getShouldShowTeamNames({
    selectedCouponChoice,
    isCompressed
  }) && React.createElement("div", {
    className: "pg_coupon_static__event_desc f-medium ".concat(isGoalCount ? 'fc-fulltraff-400' : '')
  }, React.createElement(TeamNames, {
    drawEventNumber: drawEvent.eventNumber,
    drawNumber: drawNumber,
    nameSize: nameSize,
    productId: productId,
    subDescription: isHead2Head ? 'Vem gör flest mål?' : null
  })), getIsDistributionDisplay(selectedCouponChoice) && isCompressed && React.createElement(DistributionDisplay, {
    distributionChoice: distributionChoice,
    drawNumber: drawNumber,
    eventNumber: drawEvent.eventNumber,
    productId: productId,
    selectedCouponChoice: selectedCouponChoice
  }), getShouldShowCheckmark({
    systemType,
    isResult,
    isGoalCount,
    isCompressed
  }) && React.createElement(Checkmark, {
    drawResult: drawResult,
    isGoalCount: isGoalCount,
    isResult: isResult,
    systemType: systemType,
    userRow: playerBet
  }), getShouldShowInit({
    isGoalCount,
    isCompressed,
    selectedCouponChoice,
    isSmall
  }) && React.createElement(Init, {
    drawEvent: drawEvent,
    drawNumber: drawNumber,
    drawState: drawState,
    eventNumber: drawEvent.eventNumber,
    isCompressed: isCompressed,
    isResultPage: isResult,
    productId: productId,
    selectedCouponChoice: selectedCouponChoice
  }), !isCompressed && mSign && React.createElement("span", {
    className: "pg_coupon_static__m_sign"
  }, "M"), !isCompressed && React.createElement("div", {
    className: getButtonBetClassNames()
  }, betButtonsToShow.map((result, index) => React.createElement(ButtonBet, {
    betProperties: betProperties,
    branding: branding,
    distribution: distributionForRow === null || distributionForRow === void 0 ? void 0 : distributionForRow[index],
    isCorrect: result.resultIndex === (drawResult === null || drawResult === void 0 ? void 0 : drawResult.outcome[0][0]) 
    ,
    isSelected: playerBet.includes(result.resultIndex) 
    ,
    key: result.text,
    result: result,
    uSign: uSign === index
  }))), isCompressed && React.createElement(CorrectResult, {
    betButtonsToShow: betButtonsToShow
  }), !isCompressed && React.createElement(EventComment, {
    drawEvent: drawEvent,
    drawNumber: drawNumber,
    drawResult: drawResult,
    drawState: drawState,
    productId: productId
  }), !isCompressed && isAnyTipsinfoEnabled && React.createElement("div", {
    className: "pg_coupon_static__tipsinfo"
  }, React.createElement(Tipsinfo, {
    drawId: drawId,
    drawNumber: drawNumber,
    eventNumber: drawEvent.eventNumber,
    outcomeInfoChoisesStateDisplay: outcomeInfoChoice,
    outcomeLabels: betButtons,
    productId: productId
  }))), isOngoing && drawResult && React.createElement("span", {
    "aria-live": "polite",
    className: "sr-only"
  }, composeResultUpdateText({
    eventTypeId: drawEvent === null || drawEvent === void 0 ? void 0 : drawEvent.eventTypeId,
    eventNumber: drawEvent === null || drawEvent === void 0 ? void 0 : drawEvent.eventNumber,
    eventDescription: drawEvent === null || drawEvent === void 0 ? void 0 : drawEvent.eventDescription,
    numberOfGoalsHomeTeam: drawResult === null || drawResult === void 0 ? void 0 : drawResult.home,
    numberOfGoalsAwayTeam: drawResult === null || drawResult === void 0 ? void 0 : drawResult.away,
    outcome: (_betButtons$drawResul = betButtons[drawResult === null || drawResult === void 0 ? void 0 : drawResult.outcome[0]]) === null || _betButtons$drawResul === void 0 ? void 0 : _betButtons$drawResul.sign
  })));
};
setGlobal('svs.components.tipsen.couponStatic.CouponStaticRow', CouponStaticRow);

 })(window);